import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const Subtitle = styled(Typography)({
  fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
  fontSize: '14px',
  lineHeight: '20px',
  color: '#353F48',
})
